import TableEmptyRow from 'components/others/TableEmptyRow';
import WarrantyTableRow from './WarrantyTableRow';
import type { WarrantyTableProps } from './types';

const WarrantyTableBody = (props: WarrantyTableProps) => {
    const extra = props.mini ? 0 : Object.values(props.visible || {}).filter(Boolean).length;
    return (
        <tbody>
            {props.rows.length ? (
                props.rows.map((row) => <WarrantyTableRow key={row.ID} {...props} row={row} />)
            ) : (
                <TableEmptyRow
                    colSpan={
                        (props.mini ? 5 : 6) +
                        extra +
                        (props.onSelect ? 1 : 0) -
                        (props.hideActions ? 1 : 0)
                    }
                />
            )}
        </tbody>
    );
};

export default WarrantyTableBody;
